module.exports = __webpack_public_path__ + "img/company.ddb16d49.png";